import jscookie from 'js-cookie'
import { AUTH_API_COOKIE } from '../modules/user'

const state = {
	roomBucket: null,
	bucketType: null,  		// 'building' means dont show building cols in grid
	deptSync: null,
	collegeSync: null,
}

const mutations = {
	setRoomBucket(state, payload) {
		state.roomBucket = payload
	},

	setDeptSync(state, payload) {
		state.deptSync = payload
	},

	setCollegeSync(state, payload) {
		state.collegeSync = payload
	},

	setBucketType(state, payload) {
		state.bucketType = payload
	},
}

const actions = {

};

const getters = {
/*	getDept: state => () => {
		return state.room.pct[deptSelectedIndex];
	}*/
};

export default {
	state,
	getters,
	actions,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/roomViewer.js